import { React, useEffect, useState, useRef } from 'react';
import { Link, Outlet, Route, useNavigate } from 'react-router-dom';
import ROUTES from '../../nav/Routes';

function Services() {

    return (
        <>
            <div id="hero" className="Starter section dark-background">
                <img src="assets/img/image6.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" data-aos="fade-in" />
                <div className="container">
                    <div className="row justify-content-center text-center" data-aos="fade-up" data-aos-delay="100">
                        <div className="col-xl-6 col-lg-8">
                            <h2>Services That Drive Logistics<span>.</span></h2>
                            <p>From freight transport to warehousing, we power every step of your logistics journey with care and commitment.</p>
                        </div>
                    </div>
                </div>
            </div>

            <section id="services" class="services section my-5">
                <div class="container section-title" data-aos="fade-up">
                    <h2>Our Services</h2>
                    <p>Reliable Solutions for Modern Trucking & Logistics</p>
                </div>

                <div class="container">
                    <div class="row gy-4">

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-truck"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Freight Transportation</h3>
                                </a>
                                <p>Safe and timely delivery of goods across regional and national routes.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-box-seam"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Parcel & Courier</h3>
                                </a>
                                <p>Reliable small-package delivery with real-time tracking and notifications.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-geo-alt"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>GPS Vehicle Tracking</h3>
                                </a>
                                <p>Monitor fleets in real-time to ensure route optimization and safety.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-clock-history"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Scheduled Deliveries</h3>
                                </a>
                                <p>Pre-planned delivery times to align with your business operations.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-buildings"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Warehouse & Storage</h3>
                                </a>
                                <p>Short and long-term storage solutions with proper inventory handling.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="600">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-headset"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Customer Support</h3>
                                </a>
                                <p>Dedicated helpdesk for queries, updates, and service customization.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Services;